module.exports = __webpack_public_path__ + "img/3.826099a3.jpg";